import Meter from './meter';
import TypeUtils from '@/helpers/type-utils';

export default class StatsConsumptionDistributionResponse {
  meter: Meter;
  value: number;

  static map(data: Partial<StatsConsumptionDistributionResponse>): StatsConsumptionDistributionResponse | null {
    if (!data) {
      return null;
    }

    const statistics = new StatsConsumptionDistributionResponse();

    statistics.meter = TypeUtils.hasObjectOrDefault(data.meter);
    statistics.value = TypeUtils.hasNumberOrDefault(data.value);

    return statistics;
  }

}
